import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import LazyLoad from "vanilla-lazyload";


var aLazyLoad = new LazyLoad({
	threshold:0
});

